<template>
  <div
    :class="{ 'fgas-Wrapper-disabled': disabled }"
    class="fgas-Wrapper"
    data-auto-testid="form-grade-and-status"
  >
    <FormGradeAndStatusTopBlock>
      <template #grade-block>
        <div class="fgas-Status">
          <ObjectiveStatus :based-on-grade="basedOnGrade" :status="status" show-status-mode-icon />
        </div>

        <div class="fgas-GradeBlock">
          <OkrGradeValue :grade="grade" />
        </div>
      </template>
      <template #indicator-panel>
        <IndicatorPanel
          v-if="formModel.id"
          :background-color="`rgba(${getProgressColor['--rgb-color']}, 0.5)`"
          :color="getProgressColor.color"
          :indicator-width="grade"
          rounded-bar
          style="--height: 6px; --border-radius: 6px"
        />
      </template>

      <template #status>
        <slot name="status-right" />
      </template>

      <!--    <OkrGradeChart-->
      <!--      :grade="grade"-->
      <!--      :grade-color="isManualGrade ? gradeColor : null"-->
      <!--      :predicted-score="predictedScore"-->
      <!--      :show-predicted-score="showPredictedScore"-->
      <!--      class="fgas-Chart"-->
      <!--    />-->
    </FormGradeAndStatusTopBlock>

    <FormGradeAndStatusBottomBlock
      :disabled="disabled"
      :element-target-periods="elementTargetPeriods"
      :form-model="formModel"
      :is-okr-element-closed="isOkrElementClosed"
      @save-grade="emit('save-grade', $event)"
      @open-checkin-modal="$emit('open-checkin-modal', $event)"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

// import { OKR_STATUSES } from '@/utils/objectives'
import { calculateObjectiveStatus } from '@/utils/objectives'
import { DEFAULT_MILESTONES_SETTINGS } from '@/utils/okr-element-values'
import { getGradeColorStyle } from '@/utils/okr-elements/grade'
import { OKR_ELEMENT_KEYS } from '@/utils/view-row-actions'

import FormGradeAndStatusBottomBlock from '@/components/form/FormGradeAndStatusBottomBlock'
import FormGradeAndStatusTopBlock from '@/components/form/FormGradeAndStatusTopBlock'
import OkrGradeValue from '@/components/form/OkrGradeValue'
// import OkrGradeChart from '@/components/objectives/grade-chart/OkrGradeChart'
import ObjectiveStatus from '@/components/objectives/ObjectiveStatus'
import IndicatorPanel from '@/components/ui/IndicatorPanel/IndicatorPanel'

defineOptions({
  name: 'FormGradeAndStatus'
})

const props = defineProps({
  grade: {
    type: Number,
    required: true
  },

  formModel: {
    type: Object,
    required: true
  },

  disabled: {
    type: Boolean
  },

  // predictedScore: {
  //   type: Number,
  //   default: -Infinity
  // },
  //
  // showPredictedScore: {
  //   type: Boolean
  // },

  gradeColor: {
    type: String,
    required: true
  },

  isOkrElementClosed: {
    type: Boolean
  },

  elementTargetPeriods: {
    type: Array,
    default: () => DEFAULT_MILESTONES_SETTINGS[OKR_ELEMENT_KEYS.ELEMENT_TARGET_PERIODS]
  }
})

const emit = defineEmits({
  'open-checkin-modal': null,
  'save-grade': null
})

// const isManualGrade = computed(() => {
//   return props.formModel.confidenceLevelId !== OKR_STATUSES.AUTO
// })

const getProgressColor = computed(() => {
  return getGradeColorStyle(props.gradeColor)
})

// const isNoEdit = computed(() => {
//   return props.isOkrElementClosed || props.disabled
// })

const status = computed(() => {
  return calculateObjectiveStatus(
    props.formModel[OKR_ELEMENT_KEYS.CONFIDENCE_LEVEL_ID],
    props.formModel[OKR_ELEMENT_KEYS.AUTOMATIC_CONFIDENCE_LEVEL_ID]
  )
})

const basedOnGrade = computed(() => {
  return !props.formModel[OKR_ELEMENT_KEYS.CONFIDENCE_LEVEL_ID]
})
</script>

<style lang="scss" scoped>
.fgas-Wrapper {
  display: grid;
  // gap: 24px;
  border: 2px solid $grey-3-next;
  border-radius: $border-radius-md-next;
  overflow: hidden;
  &-disabled {
    background: $grey-3-next;
  }
}

//.fgas-Chart {
//  margin-top: 4px;
//}

.fgas-Status {
  //display: flex;
  //align-items: center;
  //justify-content: space-between;
  //gap: 8px;
  overflow: hidden;
  max-width: 100%;
  margin-bottom: 8px;
  //flex-wrap: wrap;
}

// .fgas-StatusSelect {
//   overflow: hidden;
//   width: 100%;
//   // width: max-content; // prevent button stretching by height
// }

.fgas-GradeBlock {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // gap: 8px;
  gap: 10px;
}
</style>
